// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes slide-in-from-right {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes slide-in-from-left {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}
:host {
  display: block;
}

.slide-forward,
.slide-backward {
  overflow: hidden;
}

.slide-forward {
  animation: slide-in-from-right 250ms ease-out;
}

.slide-backward {
  animation: slide-in-from-left 250ms ease-out;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE;IACE,2BAAA;EACF;EACA;IACE,wBAAA;EACF;AACF;AAEA;EACE;IACE,4BAAA;EAAF;EAEA;IACE,wBAAA;EAAF;AACF;AAGA;EACE,cAAA;AADF;;AAIA;;EAEE,gBAAA;AADF;;AAIA;EACE,6CAAA;AADF;;AAIA;EACE,4CAAA;AADF","sourcesContent":["@keyframes slide-in-from-right {\r\n  from {\r\n    transform: translateX(100%);\r\n  }\r\n  to {\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n@keyframes slide-in-from-left {\r\n  from {\r\n    transform: translateX(-100%);\r\n  }\r\n  to {\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n:host {\r\n  display: block;\r\n}\r\n\r\n.slide-forward,\r\n.slide-backward {\r\n  overflow: hidden;\r\n}\r\n\r\n.slide-forward {\r\n  animation: slide-in-from-right 250ms ease-out;\r\n}\r\n\r\n.slide-backward {\r\n  animation: slide-in-from-left 250ms ease-out;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
